export const USERNAME_EMAIL_DOMAIN = "istifadeci.alsat.az";

/** İstifadəçi adını normallaşdırır: kiçik hərf, yalnız hərf/rəqəm/nöqtə/alt xətt. */
export const normalizeUsername = (raw: string) =>
  raw
    .trim()
    .toLowerCase()
    .replace(/ə/g, "e")
    .replace(/ı/g, "i")
    .replace(/ö/g, "o")
    .replace(/ü/g, "u")
    .replace(/ç/g, "c")
    .replace(/ş/g, "s")
    .replace(/ğ/g, "g")
    .replace(/[^a-z0-9._]/g, "");

/** İstifadəçi adından daxili e-poçt ünvanı düzəldir. */
export const usernameToEmail = (raw: string) =>
  `${normalizeUsername(raw)}@${USERNAME_EMAIL_DOMAIN}`;

export const validateUsername = (raw: string): string | null => {
  const u = normalizeUsername(raw);
  if (u.length < 3) return "İstifadəçi adı ən azı 3 simvol olmalıdır";
  if (u.length > 24) return "İstifadəçi adı 24 simvoldan uzun ola bilməz";
  if (!/^[a-z]/.test(u)) return "İstifadəçi adı hərflə başlamalıdır";
  return null;
};

/** Telefon nömrəsini yalnız rəqəmlərə çevirir və 994 formatına gətirir. */
export const normalizePhone = (raw: string) => {
  let d = raw.replace(/\D/g, "");
  if (d.startsWith("00")) d = d.slice(2);
  if (d.startsWith("994")) return d;
  if (d.startsWith("0")) return `994${d.slice(1)}`;
  if (d.length === 9) return `994${d}`;
  return d;
};

/** Daxil edilən mətn telefon nömrəsidirmi? */
export const looksLikePhone = (raw: string) => {
  const t = raw.trim();
  if (!/^[+\d\s()-]+$/.test(t)) return false;
  return t.replace(/\D/g, "").length >= 7;
};

export const validatePhone = (raw: string): string | null => {
  const p = normalizePhone(raw);
  if (!/^994\d{9}$/.test(p)) return "Telefon nömrəsi düzgün deyil. Nümunə: 050 123 45 67";
  return null;
};

/** Telefon nömrəsindən daxili e-poçt ünvanı düzəldir. */
export const phoneToEmail = (raw: string) =>
  `p${normalizePhone(raw)}@${USERNAME_EMAIL_DOMAIN}`;

/** Telefon və ya istifadəçi adı — hansı olduğunu özü tapır. */
export const identifierToEmail = (raw: string) =>
  looksLikePhone(raw) ? phoneToEmail(raw) : usernameToEmail(raw);

export const formatPhone = (raw: string) => {
  const p = normalizePhone(raw);
  if (!/^994\d{9}$/.test(p)) return raw;
  return `0${p.slice(3, 5)} ${p.slice(5, 8)} ${p.slice(8, 10)} ${p.slice(10)}`;
};

export const WHATSAPP_SUPPORT = "994776030335";

export const WHATSAPP_SUPPORT_LABEL = "0776030335";
export const whatsappSupportLink = (text: string) =>
  `https://wa.me/${WHATSAPP_SUPPORT}?text=${encodeURIComponent(text)}`;
